import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import qs from "qs";
import { z } from "zod";

import { type QualificationsResponse, qualificationsResponseSchema } from "../types";

const getQualificationsQuerySchema = z.object({
  filter: z
    .object({
      workplaceId: z.string().optional(),
      enabled: z.boolean().optional(),
    })
    .optional(),
});

export type GetQualificationsParams = z.infer<typeof getQualificationsQuerySchema>;

export interface UseGetQualificationsOptions extends UseGetQueryOptions<QualificationsResponse> {
  customHeaders?: Record<string, string>;
}

export function useGetQualifications(
  params: GetQualificationsParams = {},
  options: UseGetQualificationsOptions = {}
): UseQueryResult<QualificationsResponse> {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/qualifications`,
    requestSchema: z.object({ enabled: z.boolean().optional() }),
    responseSchema: qualificationsResponseSchema,
    queryParams: params,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_QUALIFICATIONS_FAILURE,
      userErrorMessage: "Failed to get qualifications",
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "comma" }),
    ...options,
  });
}
